import { Components } from '@/api/generated/api';
import { computed, ComputedRef, ref } from 'vue';
import { Api } from '@/api/api.client';
import { FilterOperationType } from '@chax-at/prisma-filter-common';
import { useQueryWithToast } from '@/composables/useQueryWithToast';
import { templateSetKeys } from '@/composables/templateSet.keys';

interface ICurrentTemplateSetComposable {
  currentTemplateSet: ComputedRef<Components.Schemas.TemplateSetDto | undefined>;
  setCurrentTemplateSet: (templateSetId?: number) => void;
}

const currentTemplateSetId = ref<number | undefined>(undefined);

export const useCurrentTemplateSet = (): ICurrentTemplateSetComposable => {
  const query = useQueryWithToast({
    queryKey: computed(() => templateSetKeys.byId(currentTemplateSetId.value)),
    enabled: computed(() => currentTemplateSetId.value != null),
    queryFn: async () =>
      (
        await Api.Routes.TemplateSet.listAllTemplateSets({
          $filter: {
            filter: [{ field: 'id', type: FilterOperationType.Eq, value: currentTemplateSetId.value! }],
            limit: 1,
          },
        })
      ).rows[0] ?? null,
  });
  const currentTemplateSet = computed(() => query.data.value ?? undefined);

  const setCurrentTemplateSet = (templateSetId?: number): void => {
    currentTemplateSetId.value = templateSetId;
  };

  return {
    currentTemplateSet,
    setCurrentTemplateSet,
  };
};
